<template>
    <div v-if="ready" class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header :header-type="'shop'"></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <div class="product-order-container">
                    <!-- 페이지 타이틀 -->
                    <div class="order-title">
                        <h1 class="order-title__text">주문/결제하기</h1>
                    </div>
                    <!-- 장바구니 -->
                    <div class="cart-list-container">
                        <!-- 장바구니 리스트 테이블 -->
                        <div class="cart-list-table">
                            <div class="tr">
                                <div class="th">상품정보</div>
                            </div>
                            <div v-for="(cart, index) in carts" :key="index" class="tr">
                                <div class="td">
                                    <div class="basket">
                                        <!-- 상품박스 -->
                                        <div class="basket__box">
                                            <div class="basket__thumb">
                                                <a class="basket__thumb-link" onclick="return false;">
                                                    <img class="basket__thumbnail" :src="cart.product.thumb" alt="" />
                                                </a>
                                            </div>
                                            <div class="basket__info">
                                                <span class="basket__title" href=""
                                                    ><a class="link" onclick="return false;">{{ cart.product.name }}</a></span
                                                >
                                                <!-- 상품 옵션 리스트 -->
                                                <div class="basket__option">
                                                    <div v-for="(pickup, index) in cart.pickups" :key="index" class="basket__option-list">
                                                        <span class="basket__option-title"
                                                            >{{ pickup.name }}<span class="basket__option-">, {{ pickup.quantity.format() }}개</span></span
                                                        >
                                                        <div class="basket__option-bottom">
                                                            <div class="basket__option-price">
                                                                <span class="price">
                                                                    <em class="num">{{ $getSaleAmount(pickup).format() }}원</em>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div>{{ pickup.requestMessage }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 가격 요약 -->
                    <div v-if="accessToken" class="order-overview">
                        <!-- 할인 내역 -->
                        <section class="order-overview__saving">
                            <section class="order-saving-container">
                                <!-- 상품 할인 쿠폰 -->
                                <order-product-coupons v-model="order.productCoupons" :coupons="me.coupons.filter((coupon) => ['product', 'category'].includes(coupon.type))" :carts="carts" />

                                <!-- 배송비 할인 쿠폰 -->
                                <order-delivery-coupons
                                    v-model="order.deliveryCoupons"
                                    :coupons="me.coupons.filter((coupon) => coupon.type == 'delivery')"
                                    :carts="carts"
                                    :shippings="shippings"
                                    :islands="islands"
                                    :postcode="this.order.receiver.postcode"
                                    @deliveryCouponAmount="(amount) => (deliveryCouponAmount = amount)"
                                />

                                <!-- 적립금 사용 -->
                                <order-point v-model="order.point" :me="me" :maxAmount="totalSaleAmount + totalDeliveryAmount + totalIslandAmount - totalCouponAmount"></order-point>
                            </section>
                        </section>

                        <!-- 총 금액 -->
                        <section class="order-overview__summary">
                            <section class="order-summary-container">
                                <section class="order-summary">
                                    <div class="col">
                                        <span class="title">상품금액</span>
                                        <span class="price"
                                            ><em class="num">{{ (totalSaleAmount + totalDiscountAmount).format() }}</em> 원</span
                                        >
                                    </div>
                                    <div class="symbol symbol--plus"></div>
                                    <div class="col">
                                        <span class="title">배송비</span>
                                        <span class="price"
                                            ><em class="num">{{ (totalDeliveryAmount + totalIslandAmount).format() }}</em> 원</span
                                        >
                                    </div>
                                    <div class="symbol symbol--minus"></div>
                                    <div class="col">
                                        <span class="title">할인금액합계</span>
                                        <span class="price price-red"
                                            ><em class="num">{{ (totalDiscountAmount + totalCouponAmount + order.point).format() }}</em> 원</span
                                        >
                                    </div>
                                </section>
                                <section class="order-summary order-summary--total">
                                    <div class="col">
                                        <span class="title">최종결제금액</span>
                                        <span class="price"
                                            ><em class="num">{{ totalOrderAmount.format() }}</em> 원</span
                                        >
                                    </div>
                                </section>
                            </section>
                        </section>
                    </div>
                    <!-- 주문 작성 폼 -->
                    <div class="order-information">
                        <section class="order-form">
                            <div class="order-form-caption">
                                <span class="title">배송지 정보 입력</span>
                                <span class="strong">*는 필수입력항목입니다.</span>
                            </div>
                            <div class="order-form-table">
                                <div v-if="accessToken && shippingDestinations.length" class="tr">
                                    <div class="th">
                                        <div>배송지 선택</div>
                                    </div>
                                    <div class="td">
                                        <div>
                                            <span v-if="basicShippingDestination" class="label-block">
                                                <label class="radio">
                                                    <input
                                                        type="radio"
                                                        name="shippingDestination"
                                                        @input="updateReceiver(basicShippingDestination)"
                                                        class="input"
                                                        :checked="order.receiver._id == basicShippingDestination._id"
                                                    />
                                                    <i class="icon"></i>
                                                    <span class="text">기본배송지</span>
                                                </label>
                                            </span>
                                            <span class="label-block">
                                                <label class="radio">
                                                    <input
                                                        type="radio"
                                                        name="shippingDestination"
                                                        @input="updateReceiver(defaultShippingDestination)"
                                                        class="input"
                                                        :checked="order.receiver._id == null"
                                                    />
                                                    <i class="icon"></i>
                                                    <span class="text">신규배송지</span>
                                                </label>
                                            </span>
                                        </div>
                                        <div>
                                            <p>최근 배송지</p>
                                            <span
                                                v-for="(shippingDestination, index) in shippingDestinations.filter((shippingDestination) => !shippingDestination.basic)"
                                                :key="index"
                                                class="label-block"
                                            >
                                                <label class="radio">
                                                    <input
                                                        type="radio"
                                                        name="shippingDestination"
                                                        @input="updateReceiver(shippingDestination)"
                                                        class="input"
                                                        :checked="order.receiver._id == shippingDestination._id"
                                                    />
                                                    <i class="icon"></i>
                                                    <span class="text">{{ shippingDestination.name }}</span>
                                                </label>
                                                <button @click="removeShippingDestination(shippingDestination)" class="delete"><span class="blind">배송지 삭제</span></button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="tr">
                                    <div class="th">
                                        <div>수령인 <span class="strong">*</span></div>
                                    </div>
                                    <div class="td">
                                        <input v-model="order.receiver.name" class="input" type="text" name="" value="" />
                                    </div>
                                </div>
                                <div v-if="me && !order.receiver._id" class="tr">
                                    <div class="th">
                                        <div>배송지 명</div>
                                    </div>
                                    <div class="td">
                                        <div class="block">
                                            <input v-model="order.receiver.title" class="input" type="text" name="" value="" />
                                            <label class="check">
                                                <input v-model="order.receiver.basic" class="input" type="checkbox" />
                                                <i class="icon"></i>
                                                <span class="text">기본배송지로 선택</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="tr">
                                    <div class="th">
                                        <div>배송지 주소 <span class="strong">*</span></div>
                                    </div>
                                    <div class="td">
                                        <!-- 주소 폼 -->
                                        <div class="form-address">
                                            <div class="row">
                                                <input v-model="order.receiver.postcode" class="input input--small" type="text" readonly @click="findAddress(order.receiver)" />
                                                <button class="button button--border-primary" type="button" @click="findAddress(order.receiver)"><span>주소찾기</span></button>
                                            </div>
                                            <div class="row">
                                                <input v-model="order.receiver.address1" class="input" type="text" readonly @click="findAddress(order.receiver)" />
                                                <input v-model="order.receiver.address2" class="input" type="text" placeholder="상세주소를 입력하세요." />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tr">
                                    <div class="th">
                                        <div>연락처 <span class="strong">*</span></div>
                                    </div>
                                    <div class="td">
                                        <!-- 연락처 폼 -->
                                        <div class="form-tel">
                                            <select v-model="order.receiver.phone1" class="select">
                                                <option value="010">010</option>
                                                <option value="011">011</option>
                                                <option value="016">016</option>
                                                <option value="017">017</option>
                                            </select>
                                            <span class="text"></span>
                                            <input v-model="order.receiver.phone2" class="input" type="tel" maxlength="4" />
                                            <span class="text"></span>
                                            <input v-model="order.receiver.phone3" class="input" type="tel" maxlength="4" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tr">
                                    <div class="th">
                                        <div>이메일 <span class="strong">*</span></div>
                                    </div>
                                    <div class="td">
                                        <!-- 이메일 폼 -->
                                        <div class="form-email">
                                            <input v-model="order.receiver.email1" class="input" type="text" @input="order.receiver.email1 = order.receiver.email1.replace(/[^0-9a-zA-Z\-.]/, '')" />
                                            <span class="text">@</span>
                                            <input v-model="order.receiver.email2" class="input" type="text" @input="order.receiver.email2 = order.receiver.email2.replace(/[^0-9a-zA-Z\-.]/, '')" />
                                            <select class="select" v-model="order.receiver.email2">
                                                <option :value="null">직접입력</option>
                                                <option v-for="item in ['naver.com', 'hanmail.net', 'google.com']" :key="item" :value="item">{{ item }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="tr">
                                    <div class="th">
                                        <div>배송요청사항</div>
                                    </div>
                                    <div class="td">
                                        <input v-model="order.requestMessage" class="input input--full" type="text" name="" value="" maxlength="50" placeholder="50자이내" />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="order-form">
                            <div class="order-form-caption">
                                <span class="title">결제 방법 선택</span>
                            </div>
                            <div class="order-form-block">
                                <div class="row">
                                    <div class="radio-block-container">
                                        <label class="radio-block"
                                            ><input v-model="order.paymentMethod" class="input" type="radio" name="payment_method" value="card" /><span class="button button--border-primary"
                                                >신용카드</span
                                            ></label
                                        >
                                        <label class="radio-block"
                                            ><input v-model="order.paymentMethod" class="input" type="radio" name="payment_method" value="account" /><span class="button button--border-primary"
                                                >무통장 입금</span
                                            ></label
                                        >
                                        <label v-show="false" class="radio-block"
                                            ><input v-model="order.paymentMethod" class="input" type="radio" name="payment_method" value="kakaopay" /><span class="button button--border-primary"
                                                >카카오페이</span
                                            ></label
                                        >
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <!-- 페이지 버튼 -->
                    <div class="order-buttons">
                        <a class="button button--border-primary" href="/"><span>취소하기</span></a>
                        <a class="button button--primary" @click="pay"><span>결제하기</span></a>
                    </div>
                </div>
            </div>

            <!-- 쿠폰사용 모달 -->
            <!-- <modal-use-coupon v-if="accessToken" ref="modal-use-coupon" v-model="me.coupons" :carts="order.carts" :totalDeliveryAmount="totalDeliveryAmount"></modal-use-coupon> -->

            <!-- 무통장 입금 모달 -->
            <modal-order-bank ref="modal-order-bank" v-model="order" @pay="submit" :totalOrderAmount="totalOrderAmount"></modal-order-bank>
        </main>

        <daum-postcode ref="daum-postcode"></daum-postcode>

        <!-- 푸터 -->
        <main-footer></main-footer>

        <ksnet-pay
            ref="ksnet-pay"
            :orderNo="order.orderNo"
            :orderName="order.orderName"
            :amount="totalOrderAmount"
            :buyerName="order.receiver.name"
            :buyerEmail="order.receiver.email"
            :buyerPhone="order.receiver.phone"
        ></ksnet-pay>
    </div>
</template>

<script>
import api from "@/api";
import axios from "@/plugins/axios";

import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import ModalUseCoupon from "@/components/client/shop/modal-use-coupon.vue";
import ModalOrderBank from "@/components/client/shop/modal-order-bank.vue";

import OrderProductCoupons from "@/components/client/shop/order-product-coupons.vue";
import OrderDeliveryCoupons from "@/components/client/shop/order-delivery-coupons.vue";
import OrderPoint from "@/components/client/shop/order-point.vue";

import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import KsnetPay from "@/components/plugins/ksnet/ksnet-pay.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        ModalUseCoupon,
        ModalOrderBank,

        OrderProductCoupons,
        OrderDeliveryCoupons,
        OrderPoint,

        DaumPostcode,
        KsnetPay,
    },
    data: function() {
        return {
            ready: false,
            showModalUseCoupon: false,
            showModalOrderBank: false,

            me: {
                // 고객정보
                // ...{ name, phone, email, ... }
                coupons: [], // 보유중인 쿠폰
            },

            deliveryCouponAmount: 0,

            order: {
                orderNo: null,
                orderName: null,

                productCoupons: [], // 상품할인 쿠폰
                deliveryCoupons: [], // 배송비 할인쿠폰

                carts: [], // 구매상품정보

                point: 0, // 사용포인트

                paymentMethod: "card", // 결제 방법

                sender: {
                    name: null,
                    phone: null,
                    email: null,
                    postcode: null,
                    address1: null,
                    address2: null,
                },
                receiver: {
                    _id: null,
                    title: null,
                    name: null,
                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,
                    email: null,
                    email1: null,
                    email2: null,
                    postcode: null,
                    address1: null,
                    address2: null,
                },
                account: {
                    accountNumber: null,
                    accountHolder: null,
                    accountBankCode: null,
                },
                cashRecipt: {
                    enabled: false,
                    phone: null,
                },
                requestMessage: null,
            },

            defaultShippingDestination: {
                _id: null,
                title: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,
            },

            shippings: [],
            islands: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        openModalUseCoupon() {
            this.$refs["modal-use-coupon"].open();
        },

        openModalOrderBank() {
            this.$refs["modal-order-bank"].open();
        },

        async init() {
            try {
                // 픽업한 상품정보 가져오기
                var { carts } = await api.v1.me.carts.getCarts({
                    params: { _carts: this._pickups },
                });

                if (!carts.length) {
                    alert("구매할 상품을 선택해주세요");
                    this.$router.go(-1);
                    return;
                }

                this.order.carts = carts;
                this.order.orderNo = `${Date.now()
                    .toDateTime()
                    .replace(/[^0-9]/g, "")}-${Math.random()
                    .toString()
                    .substr(2, 6)}`;
                this.order.orderName = 1 < carts.length ? `${carts[0].product.name} 외 ${carts.length - 1}건` : carts[0].product.name;

                var { shippings } = await api.v1.shop.shippings.getShippings({ params: { _stores: this.getStores(carts) } });
                this.shippings = shippings;

                var { islands } = await api.v1.shop.islands.getIslands({ params: { _stores: this.getStores(carts) } });
                this.islands = islands;

                if (this.accessToken) {
                    // 구매자 정보 조회
                    var { user } = await api.v1.me.getProfile();

                    var [phone1, phone2, phone3] = (user.phone || "").phoneNumberFormat().split("-");
                    var [email1, email2] = (user.email || "").split("@");

                    this.order.sender = {
                        ...user,
                        phone1,
                        phone2,
                        phone3,
                        email1,
                        email2,
                    };

                    // 보유 쿠폰 조회
                    var { coupons } = await api.v1.me.coupons.getCoupons({ params: { useDate: "null" } });

                    this.me = {
                        ...user,
                        coupons,
                    };

                    // 기본 배송지 설정
                    if (!user.shippingDestinations) user.shippingDestinations = [];
                    if (this.basicShippingDestination) this.updateReceiver(this.basicShippingDestination);
                }

                this.ready = true;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        getStores(carts) {
            return carts.reduce((stores, { _store }) => (stores.includes(_store) ? stores : [...stores, _store]), []);
        },

        pay() {
            switch (this.order.paymentMethod) {
                case "account": {
                    this.openModalOrderBank();
                    break;
                }
                case "card": {
                    this.submit();
                    break;
                }
                case "kakaopay": {
                    this.submit();
                    break;
                }
            }
        },

        async submit() {
            try {
                var orders = await this.postOrder();

                var order = orders.reduce((orders, order) => {
                    if (orders == undefined) {
                        const { _store, ...__order } = order;
                        return {
                            ...__order,
                            _stores: [_store],
                        };
                    } else {
                        orders._stores = [...orders._stores, order._store];
                        orders._pickups = [...orders._pickups, ...order._pickups];
                        orders._productCoupons = [...orders._productCoupons, ...order._productCoupons];
                        orders._deliveryCoupons = [...orders._deliveryCoupons, ...order._deliveryCoupons];

                        orders.totalSaleAmount += order.totalSaleAmount;
                        orders.totalDiscountAmount += order.totalDiscountAmount;
                        orders.totalDeliveryAmount += order.totalDeliveryAmount;
                        orders.totalIslandAmount += order.totalIslandAmount;
                        orders.totalCouponAmount += order.totalCouponAmount;
                        orders.totalPointAmount += order.totalPointAmount;
                        orders.totalOrderAmount += order.totalOrderAmount;

                        return orders;
                    }
                }, undefined);

                switch (order.paymentMethod) {
                    case "account": {
                        await this.postValidate(order.orderNo);

                        this.$router.push(`/shop/purchase?orderNo=${order.orderNo}`);

                        break;
                    }
                    case "card": {
                        // IMP.init('imp87646109'); // 'iamport' 대신 부여받은 "가맹점 식별코드"를 사용
                        // IMP.request_pay({
                        // 	pg : 'inicis', // version 1.1.0부터 지원.
                        // 	pay_method : 'card',
                        // 	merchant_uid : order.orderNo,
                        // 	name : this.carts[0].product.name,
                        // 	amount : order.totalOrderAmount,
                        // 	buyer_email : order.sender.email,
                        // 	buyer_name : order.sender.name,
                        // 	buyer_tel : order.sender.phone,
                        // 	buyer_addr : order.sender.address1,
                        // 	buyer_postcode : order.sender.postcode,
                        // 	company: "마켓쿵",
                        // 	m_redirect_url : `${window.location.protocol}//${window.location.hostname}/shop/purchase`
                        // }, (rsp) => {
                        // 	console.log({ rsp });
                        // 	this.$router.push({
                        // 		path: "/shop/purchase",
                        // 		query: {
                        // 		imp_uid: rsp.imp_uid,
                        // 		merchant_uid: rsp.merchant_uid
                        // 		}
                        // 	});
                        // });

                        this.$refs["ksnet-pay"].pay();
                        break;
                    }
                    // case "kakaopay": {
                    //     var result = await this.postKakaoPayReady(order._id);
                    //     console.log(result);

                    //     switch (this.detect) {
                    //         case "pc": {
                    //             window.location.href = result.next_redirect_pc_url;
                    //             break;
                    //         }
                    //         case "mobile": {
                    //             window.location.href = result.next_redirect_mobile_url;
                    //             break;
                    //         }
                    //     }

                    //     break;
                    // }
                }
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },

        checkPoint() {
            if (this.me.point < this.order.point) this.order.point = this.me.point;
            if (this.totalOrderAmount < this.order.point) this.order.point = this.totalOrderAmount;
        },

        findAddress(user) {
            this.$refs["daum-postcode"].open();
            this.$refs["daum-postcode"].$on("input", (data) => {
                user.postcode = data.postcode;
                user.address1 = data.address;
            });
        },

        updateReceiver(shippingDestination) {
            var [phone1, phone2, phone3] = (shippingDestination.phone || "").phoneNumberFormat().split("-");
            var [email1, email2] = (shippingDestination.email || "").split("@");

            Object.assign(this.order.receiver, {
                ...shippingDestination,
                phone1,
                phone2,
                phone3,
                email1,
                email2,
            });
        },

        async removeShippingDestination(shippingDestination) {
            try {
                if (confirm("해당 배송지를 삭제하시겠습니까?")) {
                    this.me.shippingDestinations.splice(this.me.shippingDestinations.indexOf(shippingDestination), 1);
                    await this.putMyInfo(this.me);
                }
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        postOrder() {
            return new Promise(async (resolve, reject) => {
                try {
                    var res = await axios.post("/api/v1/shop/orders", this.order);

                    resolve(res.data.orders);
                } catch (error) {
                    reject(error);
                }
            });
        },

        postValidate(orderNo) {
            return new Promise(async (resolve, reject) => {
                try {
                    var res = await axios.post("/api/v1/shop/orders/validate/account", { orderNo });

                    resolve(res.data.orderNo);
                } catch (error) {
                    reject(error);
                }
            });
        },

        // postKakaoPayReady(_order) {
        //     return new Promise(async (resolve, reject) => {
        //         try {
        //             var res = await this.$http.post('/api/kakao/payment/ready', {
        //                 _order
        //             });

        //             resolve(res.data);
        //         } catch (error) {
        //             reject(error);
        //         }
        //     });
        // },
    },
    computed: {
        ///////////////////////////////////////////////////////////////////////
        // 액세스 토큰
        ///////////////////////////////////////////////////////////////////////
        accessToken() {
            return this.$store.state.accessToken || null;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        _pickups() {
            return this.$store.state._pickups || [];
        },
        carts() {
            return this.order.carts || [];
        },
        pickups() {
            return this.carts.reduce((pickups, cart) => pickups.concat(cart.pickups), []);
        },
        ///////////////////////////////////////////////////////////////////////
        // 판매가 총액
        ///////////////////////////////////////////////////////////////////////
        totalSaleAmount() {
            return this.pickups.reduce((totalSaleAmount, pickup) => {
                return totalSaleAmount + this.$getSaleAmount(pickup);
            }, 0);
        },
        ///////////////////////////////////////////////////////////////////////
        // 할인가 총액
        ///////////////////////////////////////////////////////////////////////
        totalDiscountAmount() {
            return this.pickups.reduce((totalDiscountAmount, pickup) => {
                return totalDiscountAmount + this.$getDiscountAmount(pickup);
            }, 0);
        },
        ///////////////////////////////////////////////////////////////////////
        // 쿠폰할인금액 합계
        ///////////////////////////////////////////////////////////////////////
        totalCouponAmount() {
            var productCouponAmount = this.order.productCoupons.reduce((totalCouponAmount, coupon) => totalCouponAmount + this.$getCouponAmount(coupon, this.$getSaleAmount(coupon.pickup)), 0);
            var deliveryCouponAmount = this.deliveryCouponAmount;

            return productCouponAmount + deliveryCouponAmount;
        },
        ///////////////////////////////////////////////////////////////////////
        // 배송비 합계
        ///////////////////////////////////////////////////////////////////////
        totalDeliveryAmount() {
            var { totalDeliveryAmount, orderSaleAmount } = this.carts.reduce(
                ({ totalDeliveryAmount, orderSaleAmount }, cart) => {
                    switch (cart.product.shipping.code) {
                        case "product": {
                            totalDeliveryAmount += cart.product.shipping.price;
                            break;
                        }
                        case "order": {
                            orderSaleAmount[cart._store] = (orderSaleAmount[cart._store] || 0) + cart.pickups.reduce((totalSaleAmount, pickup) => totalSaleAmount + this.$getSaleAmount(pickup), 0);
                            break;
                        }
                    }

                    return { totalDeliveryAmount, orderSaleAmount };
                },
                { totalDeliveryAmount: 0, orderSaleAmount: {} }
            );

            if (Object.keys(orderSaleAmount).length) {
                totalDeliveryAmount += Object.keys(orderSaleAmount).reduce((sum, _store) => {
                    const orderShipping =
                        this.shippings.find((shipping) => shipping._store == _store && shipping.code == "order") ||
                        this.shippings.find((shipping) => shipping._store == undefined && shipping.code == "order");

                    return (sum += orderShipping.baseAmount <= orderSaleAmount[_store] ? orderShipping.greaterThen : orderShipping.lessThen);
                }, 0);
            }

            return totalDeliveryAmount;
        },
        ///////////////////////////////////////////////////////////////////////
        // 도서산간비용 합계
        ///////////////////////////////////////////////////////////////////////
        totalIslandAmount() {
            const filterCarts = (...codes) =>
                this.carts.filter(({ product: { shipping: { code } } }) => codes.some((__code) => __code == code));

            const getIsland = (_store) => this.islands.filter((island) => island._store == _store).find((island) => island.areas.find((area) => area.postcode == this.order.receiver.postcode)) || {};

            const solosAmount = filterCarts("product", "free").reduce((amount, cart) => {
                if (cart.product.islandEnabled) {
                    const { code } = getIsland(cart._store);

                    amount += cart.product.island.groups.find((island) => island.code == code)?.price || 0;
                }
                return amount;
            }, 0);

            const groupsAmount = filterCarts("order")
                .reduce((groups, { _store }) => (groups.includes(_store) ? groups : [...groups, _store]), [])
                .reduce((amount, _store) => {
                    const { enabled, price } = getIsland(_store);
                    if (enabled) return amount + price;
                    else return amount;
                }, 0);

            return solosAmount + groupsAmount;
        },

        totalOrderAmount() {
            if (this.ready) {
                return this.totalSaleAmount + this.totalDeliveryAmount + this.totalIslandAmount - this.totalCouponAmount - this.order.point;
            }
            return 0;
        },

        ///////////////////////////////////////////////////////////////////////
        // 배송지 목록
        ///////////////////////////////////////////////////////////////////////
        shippingDestinations() {
            return this.me.shippingDestinations || [];
        },
        ///////////////////////////////////////////////////////////////////////
        // 기본 배송지
        ///////////////////////////////////////////////////////////////////////
        basicShippingDestination() {
            return this.shippingDestinations.find((shippingDestination) => shippingDestination.basic);
        },
    },
    watch: {
        "order.receiver.phone1"() {
            this.order.receiver.phone1 = this.order.receiver.phone1.replace(/[^0-9]/, "");
            this.order.receiver.phone = [this.order.receiver.phone1, this.order.receiver.phone2, this.order.receiver.phone3].join("-");
        },
        "order.receiver.phone2"() {
            this.order.receiver.phone2 = this.order.receiver.phone2.replace(/[^0-9]/, "");
            this.order.receiver.phone = [this.order.receiver.phone1, this.order.receiver.phone2, this.order.receiver.phone3].join("-");
        },
        "order.receiver.phone3"() {
            this.order.receiver.phone3 = this.order.receiver.phone3.replace(/[^0-9]/, "");
            this.order.receiver.phone = [this.order.receiver.phone1, this.order.receiver.phone2, this.order.receiver.phone3].join("-");
        },
        "order.receiver.email1"() {
            this.order.receiver.email1 = this.order.receiver.email1.replace(/[^0-9a-zA-Z\-.]/, "");
            this.order.receiver.email = [this.order.receiver.email1, this.order.receiver.email2].join("@");
        },
        "order.receiver.email2"() {
            this.order.receiver.email2 = this.order.receiver.email2.replace(/[^0-9a-zA-Z\-.]/, "");
            this.order.receiver.email = [this.order.receiver.email1, this.order.receiver.email2].join("@");
        },

        coupons() {
            this.order._coupons = this.coupons.map((coupon) => {
                return coupon._id;
            });
        },
    },
};
</script>
